import {Page} from "@/lib/interfaces/pages";
import {apiFetch, assertJson} from "@/lib/api";

export const getPages = (page:number = 1, perPage:number = 10, offset:any = false, ignore:number[] = [], onlyFuture:any = false, type:number[] = [], sort:string[] = [], options?:{}) => {
    const params = new URLSearchParams;
    params.set('page', page.toString());
    params.set('perPage', perPage.toString());
    if (offset) {
        params.set('offset', offset);
    }
    if (ignore.length) {
        for (let i=0; i<ignore.length; i++) {
            params.set(`ignore[${i}]`, ignore[i].toString());
        }
    }
    if (onlyFuture) {
        params.set('only-future', '1');
    }
    if (type) {
        for (let i=0; i<type.length; i++) {
            params.set(`type[${i}]`, type[i].toString());
        }
    }
    if (sort) {
        for (let i=0; i<sort.length; i++) {
            params.set(`sort[${i}]`, sort[i].toString());
        }
    }
    return apiFetch(`pages?${params.toString()}`, options)
        .then(res => res.json());
}

export const getPageBySlug = (slug: string, options?:{}) => {
    return apiFetch(`pages/${slug}`, options)
        .then(resp => resp.json())
        .then(json => json.data)
        .then(data => {
            if (data) {
                const page: Page = data
                return page;
            }
            return false;
        })
        .catch((err: Error) => {
            // A 404 means the slug simply doesn't exist — let the caller handle
            // it with notFound(). Re-throw anything else (5xx, non-JSON, etc.)
            // so the error boundary fires for genuine failures.
            if (err.message.startsWith('API error 404')) return false as false;
            throw err;
        });
}

export const getFuturePages = (page: number = 1, perPage: number = 10, offset: any = false, ignore: number[] = []) => {
    const params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('perPage', perPage.toString());
    if (offset) {
        params.set('offset', offset);
    }
    if (ignore.length) {
        for (let i = 0; i < ignore.length; i++) {
            params.set(`ignore[${i}]`, ignore[i].toString());
        }
    }
    params.set('only-future', '1');

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/pages?${params.toString()}`)
        .then(assertJson)
        .then((res) => res.json())
        .then(res => {
            res.data = res.data.map((page: any) => {
                return page as Page;
            });
            return res;
        });
}